import { render, staticRenderFns } from "./editSystemGoldSetting.vue?vue&type=template&id=79811558"
import script from "./editSystemGoldSetting.vue?vue&type=script&lang=js"
export * from "./editSystemGoldSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports